import H2 from '../Atoms/H2';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Input from '../Atoms/Input';
import { useRef, useState, useEffect } from 'react';
import * as api from '../../api';
import ReCAPTCHA from 'react-google-recaptcha';
import Popup from '../Atoms/Popup';
import BlueButton from '../Atoms/BlueButton';
import { useLocation } from 'react-router-dom';
import { getRedirectFromParams, storeRedirect } from '../Utils/redirectUtils';

const Container = styled.div`
`;

const Register = (props) => {

    const { i18n } = useTranslation('common');
    const [statusMessage, setstatusMessage] = useState('');
    const [showPopup, setshowPopup] = useState(false);
    const captchaRef = useRef(null);
    const location = useLocation();

    // Check for redirect parameter on mount
    useEffect(() => {
        const redirectUrl = getRedirectFromParams(location.search);
        if (redirectUrl) {
            storeRedirect(redirectUrl);
        }
    }, [location.search]);

    const handleRegister = async (e) => {
        // console.log("handleRegister")
        e.preventDefault();
        const token = captchaRef.current.getValue();
        if(!token){
            setstatusMessage(i18n.language === "fr" ? "Captcha manquant" : "Missing captcha");
            return;
        }
        const storedRedirect = sessionStorage.getItem('postAuthRedirect');
        api.PreRegister({
            email: e.target.elements.email.value.toLowerCase(),
            captchatoken: token,
            redirect: storedRedirect || ''
        }).then((response) => {
            // console.log(response.data)
            if(response.data === "captcha not ok"){
                setstatusMessage(i18n.language === "fr" ? "Captcha invalide" : "Invalid captcha");
            }
            if(response.data === "email already registered"){
                setstatusMessage(i18n.language === "fr" ? "Vous êtes déja inscrit sur la plateforme, veuillez vous connecter." : "You are already registered on the platform, please login.");
            }
            if(response.data === "ok"){
                setshowPopup(true)
            }
        })
    }

    return (
        <Container>
            <br/>
            <H2>{i18n.language === "fr" ? "INSCRIVEZ-VOUS" : "REGISTER"}</H2><br/>
            <p style={{textAlign:'left'}}>{i18n.language === "fr" ? "Pour commencer votre inscription, merci de saisir votre adresse mail ci-dessous." : "To start your registration, please enter your email address below."}</p>
            <p style={{textAlign:'left'}}><strong>{i18n.language === "fr" ? "Attention, vous devez pouvoir accéder à cette adresse pour la valider." : "Attention, you must be able to access this address to validate it."}</strong> {i18n.language === "fr" ? "Cette adresse vous permettra de recevoir une confirmation de votre inscription." : "This address will allow you to receive a confirmation of your registration."}</p><br/>
            <form onSubmit={event => handleRegister(event)}>
                <Input required name="email" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Email" : "Email"} type="email" /><br/><br/>
                <ReCAPTCHA
                    sitekey="6LeRLgskAAAAAMF0tL5zKxXKRLigWgb6yREUsctZ"
                    ref={captchaRef}
                    // style={{margin: "0 auto 15px",width:"304px"}}
                />
                <p style={{ color: "red" }}>{statusMessage}</p><br/>
                <BlueButton><img src='/img/fleche_blanche.png' alt='' />{i18n.language === "fr" ? "S'inscrire" : "Register"}</BlueButton>
            </form>
            <br/><br/>
            {showPopup && 
                <Popup close={() => setshowPopup(false)}>
                    <p>{i18n.language === "fr" ? "Vous allez recevoir un email de confirmation pour valider votre inscription." : "You will receive a confirmation email to validate your registration."}</p>
                    <p>{i18n.language === "fr" ? "Si vous ne voyez pas le mail dans votre boite de réception, n’hésitez à vérifier dans vos spam." : "If you do not see the email in your inbox, please check your spam."}</p>
                </Popup>
            }
        </Container>
    );
}

export default Register;
